export default __webpack_public_path__ + "static/present-555f08c54d152ffdf67273f91908f3ca.svg";